module.exports = __webpack_public_path__ + "img/category_sustainability.290d76e.png";